import React from "react";

function normalizeOption(option) {
  if (option === null || option === undefined) return null;

  if (typeof option === "string" || typeof option === "number") {
    const text = String(option).trim();
    return text ? { value: text, label: text } : null;
  }

  const value = String(
    option.value ?? option.id ?? option.code ?? option.label ?? option.name ?? ""
  ).trim();
  if (!value) return null;

  const label = String(option.label ?? option.name ?? option.title ?? value).trim() || value;
  return { value, label };
}

export default function LabeledSelect({
  label,
  value,
  onChange,
  options,
  defaultLabel = "All",
  disabled = false,
}) {
  const normalizedOptions = (options || []).map(normalizeOption).filter(Boolean);

  return (
    <div className="flex flex-col gap-1.5 flex-1 min-w-[130px]">
      <label className="text-xs font-semibold text-gray-600">{label}</label>
      <div className="relative">
        <select
          value={value}
          onChange={onChange}
          disabled={disabled}
          className="w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm text-gray-700 bg-white appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent pr-8 disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed"
        >
          <option value="">{defaultLabel}</option>
          {normalizedOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <span className="absolute right-2.5 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400 text-xs">
          <svg className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400"
          fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
        </span>
      </div>
    </div>
  );
}
